document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var slides = gallery.querySelector('[data-slides]');
    var items = slides.querySelectorAll('.slide');
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    var count = gallery.querySelector('[data-count]');
    var index = 0;

    var update = function (i) {
      index = i;
      thumbs.forEach(function (t, n) {
        var active = n === i;
        t.classList.toggle('is-active', active);
        if (active) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
      });
      if (count) { count.textContent = (i + 1) + ' / ' + items.length; }
    };

    var show = function (i) {
      if (i < 0) { i = items.length - 1; }
      if (i >= items.length) { i = 0; }
      slides.scrollTo({ left: i * slides.clientWidth, behavior: 'smooth' });
      update(i);
    };

    slides.addEventListener('scroll', function () {
      var i = Math.round(slides.scrollLeft / slides.clientWidth);
      if (i !== index && i >= 0 && i < items.length) { update(i); }
    });

    var prev = gallery.querySelector('[data-prev]');
    var next = gallery.querySelector('[data-next]');
    if (prev) { prev.addEventListener('click', function () { show(index - 1); }); }
    if (next) { next.addEventListener('click', function () { show(index + 1); }); }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.getAttribute('data-thumb'), 10)); });
    });
    slides.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
    });

    var select = document.getElementById('variant-select');
    if (select) {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        var id = opt && opt.getAttribute('data-media-id');
        if (!id) { return; }
        for (var n = 0; n < items.length; n++) {
          if (items[n].getAttribute('data-media-id') === id) { show(n); break; }
        }
      });
    }
    update(0);
  }
});
